import { render, staticRenderFns } from "./lzg.vue?vue&type=template&id=1cc0caa8&scoped=true&"
import script from "./lzg.vue?vue&type=script&lang=js&"
export * from "./lzg.vue?vue&type=script&lang=js&"
import style0 from "./lzg.vue?vue&type=style&index=0&id=1cc0caa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc0caa8",
  null
  
)

export default component.exports